import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=b1141f10&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=b1141f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1141f10",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/Dashboard.vue
// module id = UE3e
// module chunks = 41